export default {
  settingsTitle: "EDO Settings",
  rentDocuments: "Exchange closing documents for space rental",
  servicesDocuments: "Exchange closing documents for service orders",
  updateSuccess: "EDO settings updated successfully",
  updateError: "Error updating EDO settings",
  contractEdoEnabled: "EDO enabled for contract",
  contractEdoDisabled: "EDO disabled for contract",
  contractUpdateError: "Error updating contract EDO",
  invitationNotice:
    "If you want to receive closing documents in the EDO system, send us an invitation:",
  companyInfo: 'JSC "EXPOCENTR", TIN 7718033809',
  edoIdLabel: "Identification number in the EDO system:",
  edoId: "2BM-7718033809-770301001-201411210937282283051",
  legalDescription:
    "An electronic document certified with a qualified electronic signature within the EDO Контур.Диадок system has the legal force of an original document. There is no need to issue paper copies of closing documents."
};
